module.exports = __webpack_public_path__ + "static/media/Spiazzi.8e557621.png";